import { Component, Inject, type OnInit } from '@angular/core';
import {
  DocumentKycUploadModalComponent,
  DocumentTypeEnum,
  KycCheckBody,
  ProcessingStatus,
} from '../document-kyc-upload-modal.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { first } from 'rxjs';
import { UploadReturn } from 'src/app/core/services/base/document.service';
import { ClaimDocumentService } from 'src/app/core/services/claim_document.service';
import { DocumentType, KycService } from 'src/app/core/services/kyc.service';
import { PersonalDocumentService } from 'src/app/core/services/personal_document.service';
import { UserService } from 'src/app/core/services/user.service';
import { BaseKycProviderComponent } from '../base-kyc-provider.component';

@Component({
  selector: 'app-veriff-kyc-provider',
  templateUrl: './veriff-kyc-provider.component.html',
  styleUrls: ['./veriff-kyc-provider.component.scss'],
})
export class VeriffKycProviderComponent
  extends BaseKycProviderComponent
  implements OnInit
{
  // Sobrescreve as opções permitidas pelo Veriff
  override options = [
    { value: DocumentTypeEnum.NATIONAL_IDENTITY_CARD, label: 'ID Card' },
    { value: DocumentTypeEnum.PASSPORT, label: 'Passport' },
    { value: DocumentTypeEnum.DRIVER_LICENSE, label: 'Driver License' },
    { value: DocumentTypeEnum.RESIDENCE_PERMIT, label: 'Residence Permit' },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    dialog: MatDialog,
    pds: PersonalDocumentService,
    cds: ClaimDocumentService,
    ks: KycService,
    us: UserService,
    dialogRef: MatDialogRef<VeriffKycProviderComponent>
  ) {
    super(data, dialog, pds, cds, ks, us, dialogRef);
    if (!data.provider) data.provider = 'veriff';
  }

  override async processUpload() {
    // Veriff não faz upload de arquivos, apenas inicia o processo KYC
    this.steps = 'PROCESSING';
    this.processing = ProcessingStatus.PROCESSING;
    try {
      const kycCheckBody: KycCheckBody = {
        provider: 'veriff',
        documentType: this.documentType as any,
        user_id: (await this.us.getCurrentUser())!.id!,
        // Não envia front_id/back_id
      };
      console.log('KYC Check Body:', kycCheckBody);

      const res = await this.ks.submitKycCheck(kycCheckBody);
      console.log('KYC Check Response:', res);

      if (!res) throw new Error('Failed to get KYC response');

      // Verifica se tem uma sessionUrl na resposta para redirecionar
      if (res.data && res.data.sessionUrl) {
        this.result = {
          status: 'VERIFF_SESSION_STARTED',
          value: res.data.sessionUrl
        };

        // Aguarda 3 segundos e redireciona para a sessão do Veriff em uma nova aba
        setTimeout(() => {
          window.open(res.data.sessionUrl, '_blank');
          // Aguarda mais um pouco e fecha o modal após redirecionar
          setTimeout(() => this.close(), 1000);
        }, 3000);

        return;
      }

      // Caso não tenha sessionUrl, continua o fluxo normal
      if (!res.id) throw new Error('Failed to get KYC check ID');
      this.checkId = res.id;
      await this.sleep(5000);
      let kycCheck = await this.ks.getById(res.id);
      if (kycCheck && kycCheck.stage === 'DONE') {
        this.processing =
          kycCheck.passed === true
            ? ProcessingStatus.APPROVED
            : ProcessingStatus.REJECTED;
        this.steps =
          this.processing === ProcessingStatus.APPROVED ? 'SUCCESS' : 'ERROR';
      } else {
        this.processing = ProcessingStatus.END_PROCESSING;
        this.steps = 'END_PROCESSING';
      }
    } catch (error) {
      this.processing = ProcessingStatus.REJECTED;
      this.steps = 'ERROR';
    } finally {
      this.progress = 100;
    }
  }

  override nextStep() {
    if (this.steps === 'TYPE-DOC') {
      // Pula direto para o processamento após escolher o tipo de documento
      this.steps = 'PROCESSING';
      this.processUpload();
    } else {
      super.nextStep();
    }
  }

  ngOnInit() {}
}
